import React from 'react'
import { Main } from './components'

const LocationOrders = () => <Main />

export default LocationOrders
